module.exports = __webpack_public_path__ + "media/profile_pictures/profile-picture-2-2a7d8e81.jpg";